import { NgModule } from '@angular/core';
import { AppTranslationModule } from '../app.translation.module';
import { SplitButtonModule, GrowlModule, MessagesModule } from 'primeng/primeng';
import { CoreModule } from '././core/core.module';
import { TooltipModule } from 'ngx-bootstrap';
import { WoService } from './work-order/work-order.service';
import { ReceivedSMSModule } from './smsreceived/receivedsms.module';
import { ShareModule } from './shared/share.module';


@NgModule({
    imports: [AppTranslationModule, CoreModule,
        SplitButtonModule, GrowlModule, MessagesModule,
        TooltipModule.forRoot(), ReceivedSMSModule, ShareModule],

    declarations: [], //LayoutComponent,MenuComponent, DetailedMenuComponent
    providers: [WoService],
    exports: [AppTranslationModule, CoreModule,
        SplitButtonModule, GrowlModule, MessagesModule, ReceivedSMSModule, ShareModule]
    //MenuComponent, DetailedMenuComponent
})
export class LayoutModule {
}